import styled from 'styled-components';
import { cssVars } from '../../../shared/lib/styledTheme';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: ${cssVars.bgColor};
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
`;

export const ModalHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid ${cssVars.borderColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 28px;
  color: ${cssVars.textSecondary};
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${cssVars.hover};
  }
`;

export const SiteList = styled.div`
  padding: 16px 24px 24px;
`;

export const SiteItem = styled.div<{ $selected?: boolean }>`
  padding: 14px 16px;
  margin-bottom: 8px;
  border-radius: 8px;
  background-color: ${props => props.$selected ? cssVars.selected : cssVars.bgSecondary};
  border: 1px solid ${props => props.$selected ? cssVars.primary : cssVars.borderColor};
  color: ${cssVars.textPrimary};
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${props => props.$selected ? cssVars.selected : cssVars.hover};
    border-color: ${cssVars.primary};
  }
`;




